import { ReactElement } from 'react';
import classnames from 'classnames';
import DiscountsIcon from '../../modules/mobile/assets/icons/DiscountsIcon';
import useStorefront from '../../hooks/storefront/useStorefront';
import useTheme from '../../hooks/ui/useTheme';
import { ButtonTypes } from '../../services/exports/Interfaces';

interface Props {
  title: string | JSX.Element;
  description: string | ReactElement;
  footer?: ReactElement;
  className?: string;
  onClick?: () => void;
}

export default function DiscountCard(props: Props): ReactElement {
  const { title, description, footer, className, onClick } = props;
  const { isStorefront } = useStorefront();
  const theme = useTheme();

  return (
    <div
      className={classnames('h-full flex bg-brand-card justify-between rounded-xl border overflow-hidden', className, {
        '!rounded-[8px]': isStorefront,
      })}
      onClick={onClick}
    >
      <div className="size-full px-md flex flex-col justify-between p-sm space-y-md">
        <div>
          <h6 className="font-semibold">{title}</h6>
          <p className="text-xs text-brand-text-secondary mt-[2px]">{description}</p>
        </div>
        {footer}
      </div>
      <div className="bg-brand-primary px-md flex h-full justify-center items-center">
        <DiscountsIcon className="h-[32px] w-[32px]" color={theme.buttons[ButtonTypes.primary].text} />
      </div>
    </div>
  );
}
